module.exports = __webpack_public_path__ + "static/media/Allcases.79f9c123.scss";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Layouts/Admin/AllCases/Allcases.scss
// module id = 536
// module chunks = 0